if (!window.fkOptionAccordionReady) {
	window.fkOptionAccordionReady = true;

	var FK_ROOT = '[data-custom-product-options]';

	// Estado que precisa sobreviver ao rebuild do bloco pelo tema.
	var fkPanelState = {};
	// Cada janela pertence a um botao: so aparece enquanto aquele botao
	// estiver aberto. Ao carregar, tudo fechado - a entrada fica limpa e
	// so a obra aparece.
	var fkWindowDismissed = { size: false, frame: false };
	// Largura com que as fotos das janelas sao pedidas ao CDN. Menor que
	// antes (eram 1200) para chegarem mais rapido, e ainda com folga para
	// o zoom do mouse.
	var FK_WINDOW_WIDTH = 1000;
	var fkPreloaded = {};
	var fkFixingCombo = false;

	function fkText(el) {
		return el && el.textContent ? el.textContent.trim() : '';
	}

	function fkIsEnglish() {
		var locale = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'pt').toLowerCase();
		return locale.indexOf('en') === 0;
	}

	function fkSelectedChoice(group) {
		var radio = group.querySelector('input[type="radio"]:checked');
		if (radio) return radio;
		var select = group.querySelector('select');
		return select ? select.options[select.selectedIndex] : null;
	}

	function fkGroupSelectedText(group) {
		var choice = fkSelectedChoice(group);
		if (choice && choice.value) return choice.value;
		return fkText(group.querySelector('[data-custom-selected-value], .js-swatch-label-name'));
	}

	function fkGroupName(group) {
		return fkText(group.querySelector('.custom-product-options__label-prefix')).replace(/\s*:\s*$/, '');
	}

	function fkGroupHandle(group) {
		return group.getAttribute('data-custom-option-handle') || '';
	}

	function fkSizeGroup(root) {
		var groups = root.querySelectorAll('[data-custom-option-group]');
		for (var i = 0; i < groups.length; i++) {
			var role = groups[i].getAttribute('data-custom-option-role');
			if (role !== 'finish' && role !== 'frame-color') return groups[i];
		}
		return null;
	}

	// ---------------------------------------------------------------
	// Fontes de imagem
	// ---------------------------------------------------------------
	function fkCdnWidth(src, width) {
		if (!src) return '';
		var clean = src.split('#')[0].replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '');
		if (clean.indexOf('//') === 0) clean = 'https:' + clean;
		return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
	}

	function fkProduct(root) {
		var section = root.closest('[data-section-type="product"]') || document;
		var tag = section.querySelector('[data-js-product-json]');
		if (!tag) return null;
		try {
			return JSON.parse(tag.innerHTML);
		} catch (error) {
			return null;
		}
	}

	function fkVariant(root) {
		var scripts = root.querySelectorAll('script[data-selected-variant]');
		var script = scripts[scripts.length - 1];
		if (!script) return null;
		try {
			return JSON.parse(script.textContent);
		} catch (error) {
			return null;
		}
	}

	// IMPORTANTE: o valor da opcao e o alt da foto nem sempre usam o mesmo
	// caractere entre os numeros. Ha produtos com "40x60 cm" (letra x) e
	// produtos com "40×60 cm" (sinal de multiplicacao). Sao caracteres
	// diferentes, entao a comparacao literal falhava e a janela ficava sem
	// imagem - era o "nada aparece". Aqui os dois lados passam pela mesma
	// normalizacao: minusculas, sinal de multiplicacao vira "x", acentos
	// fora, espacos colapsados.
	function fkNorm(value) {
		return (value || '')
			.toString()
			.toLowerCase()
			.replace(/[×✕✖]/g, 'x')
			.normalize('NFD')
			.replace(/[̀-ͯ]/g, '')
			.replace(/\s+/g, ' ')
			.trim();
	}

	function fkSizeKey(value) {
		return fkNorm(value).replace(/\s*cm\s*$/, '').replace(/[\s.]+/g, '');
	}

	// 15/09 - A CAUSA REAL DO "AS FOTOS DOS TAMANHOS NAO APARECEM".
	// Ate aqui esta funcao so olhava o ALT da foto. So o PINK HAZE tem o alt
	// dos diagramas preenchido ("20x30 cm", "30x45 cm"...) - por isso ele
	// funcionava e parecia que estava tudo certo. Em NEXT STATION, KARSTRAD,
	// ARCHITECT OF CLOUDS e companhia o alt esta VAZIO, e as fotos de tamanho
	// existem mas nunca eram encontradas.
	// Agora, se o alt nao resolver, procura pelo NOME DO ARQUIVO, que segue o
	// padrao do pipeline dela: "Next_Station_20x30_<codigo>.png".
	// Dois detalhes que faziam falta:
	//  - Nas obras HORIZONTAIS o arquivo vem com os numeros ao contrario da
	//    opcao: a opcao diz "20x30 cm" e o arquivo e "Karstrad_30x20.png".
	//    Por isso procura o par nas DUAS ordens.
	//  - "20x30" nao pode casar dentro de "120x30", entao o par tem que estar
	//    cercado por algo que nao seja digito.
	function fkSizePair(value) {
		var m = fkNorm(value).match(/(\d{1,4})\s*x\s*(\d{1,4})/);
		return m ? { a: m[1], b: m[2] } : null;
	}

	function fkFileName(src) {
		var s = (src || '').toString().split('?')[0];
		var i = s.lastIndexOf('/');
		return fkNorm(i === -1 ? s : s.slice(i + 1));
	}

	function fkFileHasSize(fileName, pair) {
		if (!fileName || !pair) return false;
		var re = new RegExp(
			'(^|[^0-9])(' + pair.a + '\\s*x\\s*' + pair.b + '|' + pair.b + '\\s*x\\s*' + pair.a + ')([^0-9]|$)'
		);
		return re.test(fileName);
	}

	function fkSizeMediaSrc(root, sizeValue) {
		if (!sizeValue) return '';
		var product = fkProduct(root);
		if (!product || !product.media || !product.media.length) return '';

		var wanted = fkNorm(sizeValue);
		var digits = fkSizeKey(sizeValue);
		var pair = fkSizePair(sizeValue);
		var exact = '';
		var contains = '';
		var loose = '';
		// Pelo nome do arquivo guarda a ULTIMA que casar, e prefere .png:
		// as fotos novas do pipeline sao .png e entram depois na galeria; as
		// .jpg soltas sao sobras antigas do mesmo tamanho (ex.: ARCHITECT OF
		// CLOUDS tem "..._30x20_S.jpg" velho e "..._30x20_<codigo>.png" novo).
		var byFile = '';
		var byFilePng = '';

		for (var i = 0; i < product.media.length; i++) {
			var media = product.media[i];
			var src = media.src || (media.preview_image && media.preview_image.src) || '';
			if (!src) continue;

			var alt = fkNorm(media.alt);

			if (alt) {
				if (alt === wanted) {
					exact = src;
					break;
				}
				if (!contains && alt.indexOf(wanted) !== -1) contains = src;
				if (!loose && digits && fkSizeKey(alt).indexOf(digits) !== -1) loose = src;
			}

			var file = fkFileName(src);
			// Os mockups de moldura nunca sao diagrama de tamanho.
			if (file.indexOf('moldura') !== -1) continue;
			if (fkFileHasSize(file, pair)) {
				byFile = src;
				if (/\.png$/.test(file)) byFilePng = src;
			}
		}

		return exact || contains || loose || byFilePng || byFile || '';
	}

	function fkFrameMediaSrc(root) {
		var variant = fkVariant(root);
		var media = variant && variant.featured_media;
		return (media && media.preview_image && media.preview_image.src) || '';
	}

	// ---------------------------------------------------------------
	// Janelas - vivem FORA de .js-product-options
	// ---------------------------------------------------------------
	function fkEnsureWindow(root, kind) {
		var existing = root.querySelector('[data-fk-window="' + kind + '"]');
		if (existing) return existing;

		var box = document.createElement('div');
		box.className = 'fk-window';
		box.setAttribute('data-fk-window', kind);
		box.hidden = true;
		box.innerHTML =
			'<button type="button" class="fk-window__close" data-fk-window-close="' + kind + '" aria-label="' +
			(fkIsEnglish() ? 'Close' : 'Fechar') + '">&times;</button>' +
			'<img class="fk-window__img" alt="" data-fk-window-img>' +
			'<span class="fk-window__caption" data-fk-window-caption></span>';

		var options = root.querySelector('.js-product-options');
		root.insertBefore(box, options || root.firstChild);
		return box;
	}

	// 14/09 (rodada 3): a visibilidade da janela deixou de depender de o
	// painel-sanfona estar aberto. Agora cada janela tem um "ativada" que
	// liga ao escolher um valor daquela categoria (ou abrir o botao dela)
	// e so desliga se a pessoa fechar no X. Assim, trocar de categoria no
	// acordeao (abrir TAMANHO depois de ACABAMENTO, por exemplo) nao
	// esconde mais a janela da outra - as duas convivem, como pedido:
	// escolher um tamanho traz de volta a foto do tamanho mesmo depois de
	// ter mexido na moldura, e escolher uma moldura mostra as duas fotos
	// (tamanho + moldura) juntas.
	var fkWindowActivated = { size: false, frame: false };

	function fkWindowShouldShow(root, kind) {
		if (fkWindowDismissed[kind]) return false;
		return !!fkWindowActivated[kind];
	}

	function fkPaintWindow(root, kind, src, caption) {
		var box = fkEnsureWindow(root, kind);

		if (!src || !fkWindowShouldShow(root, kind)) {
			box.hidden = true;
			return;
		}

		var image = box.querySelector('[data-fk-window-img]');
		var wide = fkCdnWidth(src, FK_WINDOW_WIDTH);
		if (image.getAttribute('src') !== wide) image.setAttribute('src', wide);
		image.alt = caption || '';
		box.querySelector('[data-fk-window-caption]').textContent = caption || '';
		box.hidden = false;
	}

	// ---------------------------------------------------------------
	// Desarmar a logica antiga do bloco 1 (armadilha 2)
	// ---------------------------------------------------------------
	function fkNeutralizeLegacy(root) {
		var toggle = root.querySelector('[data-frame-toggle]');
		if (toggle && toggle.parentNode) toggle.parentNode.removeChild(toggle);

		if (root.dataset && root.dataset.frameMode) delete root.dataset.frameMode;
		window.customProductFrameMode = '';

		root.querySelectorAll('[data-custom-option-group][hidden]').forEach(function (group) {
			group.removeAttribute('hidden');
		});
	}

	function fkNeutralizeAll() {
		document.querySelectorAll(FK_ROOT).forEach(fkNeutralizeLegacy);
	}

	// ---------------------------------------------------------------
	// Armadilha 3: os acabamentos tem que continuar sempre clicaveis
	// ---------------------------------------------------------------
	function fkEnableFinishOptions(root) {
		var finishGroup = root.querySelector('[data-custom-option-role="finish"]');
		if (!finishGroup) return;

		finishGroup.querySelectorAll('input[type="radio"][disabled]').forEach(function (input) {
			input.disabled = false;
		});

		finishGroup.querySelectorAll('.is-disabled').forEach(function (label) {
			label.classList.remove('is-disabled');
		});

		var select = finishGroup.querySelector('select');
		if (select) {
			Array.prototype.forEach.call(select.options, function (option) {
				option.disabled = false;
				option.hidden = false;
			});
		}
	}

	// ---------------------------------------------------------------
	// Botoes sanfona
	// ---------------------------------------------------------------
	function fkBuildAccordion(root) {
		fkNeutralizeLegacy(root);
		fkEnableFinishOptions(root);

		root.querySelectorAll('[data-custom-option-group]').forEach(function (group) {
			if (group.getAttribute('data-fk-acc') === '1') return;
			group.setAttribute('data-fk-acc', '1');

			var handle = fkGroupHandle(group);
			group.classList.add('fk-acc-panel');
			// Reaplica o que a pessoa deixou aberto, em vez de fechar tudo.
			group.classList.toggle('fk-acc-closed', !fkPanelState[handle]);

			var button = document.createElement('button');
			button.type = 'button';
			button.className = 'fk-acc-btn';
			button.setAttribute('data-fk-acc-btn', '');
			button.setAttribute('data-fk-acc-for', handle);
			button.innerHTML =
				'<span class="fk-acc-btn__name" data-fk-acc-name></span>' +
				'<span class="fk-acc-btn__value" data-fk-acc-value></span>' +
				'<span class="fk-acc-btn__chev" aria-hidden="true"></span>';

			button.querySelector('[data-fk-acc-name]').textContent = fkGroupName(group);
			button.setAttribute('aria-expanded', String(!!fkPanelState[handle]));
			group.parentNode.insertBefore(button, group);
		});
	}

	function fkFindGroupForButton(root, button) {
		var handle = button.getAttribute('data-fk-acc-for');
		return root.querySelector('[data-custom-option-group][data-custom-option-handle="' + handle + '"]');
	}

	function fkSyncRoot(root) {
		fkBuildAccordion(root);

		root.querySelectorAll('[data-fk-acc-btn]').forEach(function (button) {
			var group = fkFindGroupForButton(root, button);
			if (!group) return;
			button.querySelector('[data-fk-acc-value]').textContent = fkGroupSelectedText(group);
			button.setAttribute('aria-expanded', String(!group.classList.contains('fk-acc-closed')));
		});

		var finishGroup = root.querySelector('[data-custom-option-role="finish"]');
		var colorGroup = root.querySelector('[data-custom-option-role="frame-color"]');
		var sizeGroup = fkSizeGroup(root);
		// "So impressao" = o acabamento que so existe com UMA cor. Vem dos
		// dados do produto, nao da marcacao do Liquid - assim funciona
		// mesmo nos produtos em que o Liquid nao consegue deduzir isso.
		var printOnly = finishGroup ? fkIsPrintOnly(root, fkGroupSelectedText(finishGroup)) : false;

		if (finishGroup && colorGroup) {
			var colorButton = root.querySelector('[data-fk-acc-btn][data-fk-acc-for="' + fkGroupHandle(colorGroup) + '"]');
			if (colorButton) colorButton.hidden = printOnly;
			colorGroup.classList.toggle('fk-acc-force-hidden', printOnly);

			// Rede de seguranca: "Moldura simples" com a cor "Sem moldura" nao
			// forma variante nenhuma, e a Shopify mostra "Indisponivel" no
			// botao de comprar. O listener de captura cobre a troca feita pelo
			// cliente; isto cobre o resto (carregamento da pagina, voltar do
			// historico, quick view). Corrige a cor para a primeira valida.
			if (!fkFixingCombo && fkRepairCombo(root, finishGroup, colorGroup)) return;
		}

		// Janela do tamanho: mostra enquanto estiver "ativada" (aberta ou
		// escolhida) e nao tiver sido fechada no X. A imagem acompanha o
		// tamanho escolhido.
		var sizeValue = sizeGroup ? fkGroupSelectedText(sizeGroup) : '';
		fkPaintWindow(root, 'size', fkSizeMediaSrc(root, sizeValue), sizeValue);

		// Janela da moldura: mesma logica, para ACABAMENTO/COR DA MOLDURA.
		// Em "Somente impressao" nao ha moldura.
		var frameCaption = '';
		var frameSrc = '';

		if (!printOnly && finishGroup) {
			var finishText = fkGroupSelectedText(finishGroup);
			var colorText = colorGroup ? fkGroupSelectedText(colorGroup) : '';
			frameCaption = colorText ? finishText + ' · ' + colorText : finishText;
			frameSrc = fkFrameMediaSrc(root);
		}

		fkPaintWindow(root, 'frame', frameSrc, frameCaption);
	}

	function fkSyncAll() {
		document.querySelectorAll(FK_ROOT).forEach(fkSyncRoot);
	}

	// ---------------------------------------------------------------
	// Pre-carregamento: sem isto a janela abre vazia e a foto so entra
	// depois de baixar - era o "nao aparece imediatamente". Baixando por
	// baixo dos panos logo no inicio, ao abrir a janela a foto ja esta no
	// cache do navegador e aparece na hora.
	// ---------------------------------------------------------------
	function fkPreload(src) {
		if (!src || fkPreloaded[src]) return;
		fkPreloaded[src] = true;
		var image = new Image();
		image.decoding = 'async';
		image.src = src;
	}

	function fkPreloadSizes(root) {
		var sizeGroup = fkSizeGroup(root);
		if (!sizeGroup) return;

		var values = sizeGroup.querySelectorAll('input[type="radio"], option');

		for (var i = 0; i < values.length; i++) {
			var src = fkSizeMediaSrc(root, values[i].value);
			if (src) fkPreload(fkCdnWidth(src, FK_WINDOW_WIDTH));
		}
	}

	function fkPreloadFrames(root) {
		var product = fkProduct(root);
		if (!product || !product.variants) return;

		product.variants.forEach(function (variant) {
			var media = variant && variant.featured_media;
			var src = media && media.preview_image && media.preview_image.src;
			if (src) fkPreload(fkCdnWidth(src, FK_WINDOW_WIDTH));
		});
	}

	// ---------------------------------------------------------------
	// Combinacoes validas, lidas do proprio produto
	// (opcao 0 = Tamanho, 1 = Acabamento, 2 = Cor da moldura)
	// ---------------------------------------------------------------
	function fkColorsForFinish(root, finish) {
		var product = fkProduct(root);
		var colors = [];
		if (!product || !product.variants || !finish) return colors;

		product.variants.forEach(function (variant) {
			if (!variant.options || variant.options[1] !== finish) return;
			var color = variant.options[2];
			if (color && colors.indexOf(color) === -1) colors.push(color);
		});

		return colors;
	}

	function fkIsPrintOnly(root, finish) {
		return fkColorsForFinish(root, finish).length === 1;
	}

	// Devolve true se precisou corrigir (e ja disparou a troca).
	function fkRepairCombo(root, finishGroup, colorGroup) {
		var finish = fkGroupSelectedText(finishGroup);
		var current = fkGroupSelectedText(colorGroup);
		var allowed = fkColorsForFinish(root, finish);

		if (!allowed.length || allowed.indexOf(current) !== -1) return false;

		var wanted = allowed[0];
		var radios = colorGroup.querySelectorAll('input[type="radio"]');

		for (var i = 0; i < radios.length; i++) {
			if (radios[i].value === wanted) {
				fkFixingCombo = true;
				setTimeout(function () {
					fkFixingCombo = false;
				}, 600);
				radios[i].click();
				return true;
			}
		}

		var select = colorGroup.querySelector('select');

		if (select && select.value !== wanted) {
			fkFixingCombo = true;
			setTimeout(function () {
				fkFixingCombo = false;
			}, 600);
			select.value = wanted;
			select.dispatchEvent(new Event('change', { bubbles: true }));
			return true;
		}

		return false;
	}

	// Captura o "change" do ACABAMENTO ANTES do tema: se a cor atual nao
	// existe com o acabamento escolhido, troca a cor aqui mesmo (sem
	// disparar evento). O tema le todos os inputs marcados na sequencia,
	// entao a variante certa vem numa unica ida ao servidor.
	document.addEventListener('change', function (event) {
		var input = event.target;
		if (!input || input.type !== 'radio') return;

		var group = input.closest('[data-custom-option-group]');
		if (!group || group.getAttribute('data-custom-option-role') !== 'finish') return;

		var root = group.closest(FK_ROOT);
		var colorGroup = root && root.querySelector('[data-custom-option-role="frame-color"]');
		if (!colorGroup) return;

		var allowed = fkColorsForFinish(root, input.value);
		if (!allowed.length) return;

		var currentColor = fkGroupSelectedText(colorGroup);
		if (allowed.indexOf(currentColor) !== -1) return;

		var wanted = allowed[0];
		var radios = colorGroup.querySelectorAll('input[type="radio"]');

		for (var i = 0; i < radios.length; i++) {
			if (radios[i].value === wanted) {
				radios[i].checked = true;
				break;
			}
		}
	}, true);

	// 14/09 (rodada 3): pedido da Fabiana - escolher um TAMANHO tem que
	// trazer de volta a foto do tamanho mesmo que a pessoa tenha acabado
	// de mexer na moldura; e escolher uma MOLDURA (acabamento ou cor) tem
	// que mostrar as duas fotos juntas (tamanho + moldura). Antes, a
	// janela so aparecia enquanto o painel-sanfona daquela categoria
	// estivesse aberto - agora a escolha de um valor "ativa" a janela
	// certa direto, independente de qual painel esta aberto no momento.
	document.addEventListener('change', function (event) {
		var input = event.target;
		if (!input || (input.tagName !== 'INPUT' && input.tagName !== 'SELECT')) return;

		var group = input.closest('[data-custom-option-group]');
		if (!group) return;

		var root = group.closest(FK_ROOT);
		var role = group.getAttribute('data-custom-option-role');
		var isFrame = role === 'finish' || role === 'frame-color';

		if (isFrame) {
			fkWindowDismissed.frame = false;
			fkWindowActivated.frame = true;
			// Mostra as duas fotografias: tamanho + moldura escolhida.
			fkWindowDismissed.size = false;
			fkWindowActivated.size = true;
			if (root) fkPreloadFrames(root);
		} else {
			fkWindowDismissed.size = false;
			fkWindowActivated.size = true;
		}
	}, true);

	// ---------------------------------------------------------------
	// Mockups de moldura fora da galeria (uma vez, no carregamento)
	// ---------------------------------------------------------------
	function fkVariantMediaIds(sectionEl) {
		var tag = sectionEl.querySelector('[data-js-product-json]');
		if (!tag) return null;

		var product;
		try {
			product = JSON.parse(tag.innerHTML);
		} catch (error) {
			return null;
		}

		if (!product || !product.variants || !product.variants.length) return null;

		var ids = {};
		var total = 0;

		product.variants.forEach(function (variant) {
			var media = variant && variant.featured_media;
			if (!media || !media.id) return;
			var key = String(media.id);
			if (!ids[key]) total++;
			ids[key] = true;
		});

		return total ? ids : null;
	}

	function fkDropSlides(container, slideSelector, idAttribute, ids) {
		if (!container) return false;

		var slides = container.querySelectorAll(slideSelector);
		if (!slides.length) return false;

		var doomed = [];

		for (var i = 0; i < slides.length; i++) {
			var id = slides[i].getAttribute(idAttribute);
			if (id && ids[String(id)]) doomed.push(slides[i]);
		}

		// Trava: se tudo casar, nao remove nada.
		if (!doomed.length || doomed.length >= slides.length) return false;

		doomed.forEach(function (slide) {
			slide.parentNode.removeChild(slide);
		});

		return true;
	}

	function fkFilterGallery() {
		document.querySelectorAll('[data-section-type="product"][data-section-id]').forEach(function (sectionEl) {
			if (sectionEl.getAttribute('data-fk-media-filtered') === '1') return;

			var mainSlider = sectionEl.querySelector('[data-js-product-media-slider]');
			if (!mainSlider) return;

			sectionEl.setAttribute('data-fk-media-filtered', '1');

			var ids = fkVariantMediaIds(sectionEl);
			if (!ids) return;

			var thumbs = sectionEl.querySelector('.product-media__slider-thumbnails');
			var zoomWrapper = sectionEl.querySelector('[data-zoom-content]');

			fkDropSlides(mainSlider, '.swiper-slide[data-media-id]', 'data-media-id', ids);
			fkDropSlides(thumbs, '.swiper-slide[data-media-id]', 'data-media-id', ids);
			var zoomChanged = fkDropSlides(zoomWrapper, '[data-zoom-slide]', 'data-zoom-slide', ids);

			[mainSlider, thumbs].forEach(function (element) {
				if (!element) return;
				var remaining = element.querySelectorAll('.swiper-slide[data-media-id]');
				for (var i = 0; i < remaining.length; i++) {
					remaining[i].setAttribute('data-slide-index', String(i));
				}
			});

			[mainSlider, thumbs].forEach(function (element) {
				if (element && element.swiper && typeof element.swiper.update === 'function') {
					element.swiper.update();
				}
			});

			if (zoomChanged && window.themeCore && window.themeCore.EventBus) {
				window.themeCore.EventBus.emit('zoom:slides-updated');
			}
		});
	}

	// ---------------------------------------------------------------
	// Texto do botao de checkout dinamico da Shopify.
	// O bloco 2 do custom-product-options-js ja encurta "Buy it now" ->
	// "Buy now" no ingles. Aqui vai o portugues: "Compre ja" -> "Comprar",
	// como ela pediu. Nao ha risco de laco entre os dois: cada um so mexe
	// quando encontra o seu proprio texto, e depois de trocado nenhum dos
	// dois casa de novo.
	// ---------------------------------------------------------------
	function fkBuyButtonLabel() {
		if (typeof document === 'undefined' || !document.querySelectorAll) return;

		document.querySelectorAll('.shopify-payment-button__button').forEach(function (button) {
			var text = (button.textContent || '').trim();
			if (text === 'Compre ja' || text === 'Compre já' || text === 'Comprar já' || text === 'Comprar ja') {
				button.textContent = 'Comprar';
			}
		});
	}

	new MutationObserver(fkBuyButtonLabel).observe(document.body, { childList: true, subtree: true, characterData: true });

	// ---------------------------------------------------------------
	// Eventos
	// ---------------------------------------------------------------
	document.addEventListener('click', function (event) {
		var closer = event.target.closest('[data-fk-window-close]');

		if (closer) {
			event.preventDefault();
			var kind = closer.getAttribute('data-fk-window-close');
			fkWindowDismissed[kind] = true;
			var box = closer.closest('[data-fk-window]');
			if (box) box.hidden = true;
			return;
		}

		var button = event.target.closest('[data-fk-acc-btn]');
		if (!button) return;

		event.preventDefault();
		var root = button.closest(FK_ROOT);
		var group = root && fkFindGroupForButton(root, button);
		if (!group) return;

		var willOpen = group.classList.contains('fk-acc-closed');
		var role = group.getAttribute('data-custom-option-role');
		var isFrame = role === 'finish' || role === 'frame-color';

		// 14/09: so uma categoria de painel-sanfona (lista de opcoes) por
		// vez - TAMANHO de um lado, ACABAMENTO/COR DA MOLDURA do outro.
		// Isto e so sobre a LISTA DE OPCOES ficar aberta; a janela de
		// visualizacao (foto) de cada categoria agora e independente disto
		// (ver fkWindowActivated) e pode continuar aparecendo mesmo com o
		// painel da outra categoria fechado.
		if (willOpen && root) {
			root.querySelectorAll('[data-fk-acc-btn]').forEach(function (otherButton) {
				if (otherButton === button) return;
				var otherGroup = fkFindGroupForButton(root, otherButton);
				if (!otherGroup) return;
				var otherRole = otherGroup.getAttribute('data-custom-option-role');
				var otherIsFrame = otherRole === 'finish' || otherRole === 'frame-color';
				if (otherIsFrame === isFrame) return;
				fkPanelState[otherButton.getAttribute('data-fk-acc-for')] = false;
				otherGroup.classList.add('fk-acc-closed');
				otherButton.setAttribute('aria-expanded', 'false');
			});
		}

		fkPanelState[button.getAttribute('data-fk-acc-for')] = willOpen;
		group.classList.toggle('fk-acc-closed', !willOpen);
		button.setAttribute('aria-expanded', String(willOpen));

		// Abrir um botao traz de volta a janela dele, mesmo que o cliente
		// tenha fechado no X antes.
		if (willOpen) {
			var kind2 = isFrame ? 'frame' : 'size';
			fkWindowDismissed[kind2] = false;
			fkWindowActivated[kind2] = true;
			if (isFrame) fkPreloadFrames(root);
		}

		fkSyncAll();
	});

	document.addEventListener('change', function () {
		requestAnimationFrame(fkSyncAll);
	});

	var fkScheduled = false;
	new MutationObserver(function (mutations) {
		var touched = mutations.some(function (mutation) {
			if (!mutation.target || !mutation.target.closest) return false;
			if (mutation.target.closest(FK_ROOT)) return true;
			if (mutation.type !== 'childList') return false;
			return Array.from(mutation.addedNodes).some(function (node) {
				return node.nodeType === 1 && (node.matches(FK_ROOT) || node.querySelector(FK_ROOT));
			});
		});

		if (!touched) return;

		// Sincrono de proposito: precisa acontecer antes dos rAF.
		fkNeutralizeAll();

		if (fkScheduled) return;
		fkScheduled = true;
		requestAnimationFrame(function () {
			fkScheduled = false;
			fkSyncAll();
		});
	}).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });

	function fkStart() {
		fkFilterGallery();
		fkNeutralizeAll();
		fkSyncAll();
		fkBuyButtonLabel();
		document.querySelectorAll(FK_ROOT).forEach(fkPreloadSizes);
	}

	document.addEventListener('shopify:section:load', function () {
		requestAnimationFrame(fkStart);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fkStart);
	} else {
		fkStart();
	}

	document.addEventListener('theme:all:loaded', fkStart, { once: true });
	setTimeout(fkStart, 1500);
}
